// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__2a-oT","links":"Project_links__3Lxdj"};